<template>
  <div class="columnList">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>栏目管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>名称:</span>
      <el-input
        v-model.trim="list.columnName"
        placeholder="请输入栏目名称"
      ></el-input>
      <el-button type="primary" @click="onSearch">搜索</el-button>
      <el-button
        type="primary"
        @click="addDialogVisible = true"
        v-if="
          $store.state.powerList.indexOf('system:permission:column:insert') !==
          -1
        "
        >添加</el-button
      >
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="columnSort"
        label="排序"
        width="180"
      >
        <template slot-scope="{ row }">
          <el-input
            class="input-new-tag"
            v-if="row.inputVisible"
            v-model="row.columnSort"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm(row)"
            @blur="handleInputConfirm(row)"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="onChangeSort(row)"
            >{{ row.columnSort }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column align="center" prop="columnId" label="ID" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="columnName"
        label="栏目名称"
        width="180"
      >
      </el-table-column>
      <el-table-column align="center" label="图标">
        <template slot-scope="{ row }">
          <i :class="row.columnIcon" class="iconfont"></i>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="columnTier" label="级别">
        <template slot-scope="{ row }">
          <el-tag v-if="row.columnTier === 1">顶级</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="columnCreateTime"
        label="栏目创建时间"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="{ row }">
          <el-button type="primary" @click="onAddSecondColunm(row)" size="mini"
            >查看下级</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="onDel(row)"
            v-if="
              $store.state.powerList.indexOf(
                'system:permission:column:delete'
              ) !== -1
            "
            >删除</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="onEditColunm(row)"
            v-if="
              $store.state.powerList.indexOf(
                'system:permission:column:update'
              ) !== -1
            "
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-button
      class="btn"
      type="primary"
      @click="onAllDelColumn"
      v-if="
        $store.state.powerList.indexOf('system:permission:column:delete') !== -1
      "
      >批量删除</el-button
    >
    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="list.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
    >
    </el-pagination> -->
    <el-dialog
      title="添加一级栏目"
      :visible.sync="addDialogVisible"
      width="30%"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="栏目名称">
          <el-input
            placeholder="请输入要添加的栏目名称"
            v-model.trim="addform.columnName"
          ></el-input>
        </el-form-item>
        <el-form-item label="栏目图标">
          <el-input
            placeholder="请输入图表库中的图标"
            v-model.trim="addform.columnIcon"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAddColumn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑一级栏目"
      :visible.sync="editDialogVisible"
      width="30%"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="栏目主键">
          <el-input
            placeholder="请输入要添加的栏目名称"
            v-model="editColumnList.columnId"
            readonly=""
          ></el-input>
        </el-form-item>
        <el-form-item label="栏目图标">
          <el-input
            placeholder="请输入图表库中的图标"
            v-model="editColumnList.columnIcon"
          ></el-input>
        </el-form-item>
        <el-form-item label="栏目名称">
          <el-input
            placeholder="请输入栏目名称"
            v-model="editColumnList.columnName"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditColumnOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  columnList,
  addColumn,
  editSort,
  editColumn,
  delColum,
} from "../../api/column";
export default {
  name: "ColumnList",
  data() {
    return {
      tableData: [],
      value: [],
      addDialogVisible: false,
      editDialogVisible: false,
      addSecondDialogVisible: false,
      pagination: {},
      addform: {
        columnName: "",
        columnIcon: "",
        columnTier: 1,
      },
      list: {
        roleId: "",
        columnTier: "",
        parentId: "",
        columnName: "",
        currentPage: 1,
        pageSize: 99999,
      },
      editColumnList: {},
      addSecondColumn: {},
      pagination: null,
    };
  },
  created() {
    this.getColumnList();
  },
  methods: {
    async getColumnList() {
      const { data } = await columnList(this.list);
      this.pagination = data.pagination;
      data.list.map((item) => {
        item.inputVisible = false;
      });
      const list = data.list.filter((item) => {
        return item.columnParentId === 0 || item.columnParentId === null;
      });
      this.tableData = list;
    },
    onDel(row) {
      this.$confirm("是否删除这条栏目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await delColum({
            columnIdListStr: [row.columnId],
          });
          if (data.code === 0) {
            this.getColumnList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: "删除失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSearch() {
      this.getColumnList();
      this.list.columnName = "";
    },
    onChangeSort(row) {
      row.inputVisible = true;
    },
    async handleInputConfirm(row) {
      const { data } = await editSort({
        columnId: row.columnId,
        columnSort: row.columnSort,
      });
      row.inputVisible = false;
      this.getColumnList();
    },
    onEditColunm(row) {
      this.editColumnList = row;
      this.editDialogVisible = true;
    },
    async onEditColumnOk() {
      if (
        this.editColumnList.columnIcon === "" ||
        this.editColumnList.columnName === ""
      ) {
        this.$message({
          showClose: true,
          message: "请把数据填写完整!",
          type: "warning",
        });
        return;
      }
      const { data } = await editColumn(this.editColumnList);
      console.log(data);
      if (data.code === 0) {
        this.$message({
          showClose: true,
          message: "编辑成功",
          type: "success",
        });
      } else {
        this.$message({
          showClose: true,
          message: "编辑失败请稍后重试",
          type: "warning",
        });
      }
      this.editDialogVisible = false;
    },
    async onAddColumn() {
      if (this.addform.columnName === "" || this.addform.columnName === "") {
        this.$message({
          showClose: true,
          message: "请把数据填写完整!",
          type: "warning",
        });
        return;
      }
      const { data } = await addColumn(this.addform);
      if (data.code === 0) {
        this.$message({
          showClose: true,
          message: "添加一级栏目成功",
          type: "success",
        });
      }
      this.addDialogVisible = false;
      this.getColumnList();
    },
    handleSelectionChange(val) {
      var arr = [];
      val.map((item) => {
        arr.push(item.columnId);
      });
      this.value = arr;
    },
    onAllDelColumn() {
      console.log(this.value);
      this.$confirm("是否批量删除这条栏目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await delColum({
            columnIdListStr: this.value,
          });
          if (data.code === 0) {
            this.getColumnList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: "删除失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(sixe) {
      this.list.pageSize = sixe;
      this.getColumnList();
    },
    handleCurrentChange(Current) {
      this.list.currentPage = Current;
      this.getColumnList();
    },

    onAddSecondColunm(row) {
      this.$router.push(`/secondcolumnlist/${row.columnId}`);
    },
    async onAddSecondColumnOk() {
      const { data } = await addColumn({
        columnName: this.addSecondColumn.secondColumnName,
        columnIcon: this.addSecondColumn.columnIcon,
        columnTier: this.addSecondColumn.columnTier,
        columnParentId: this.addSecondColumn.columnId,
      });
      console.log(data);
    },
  },
};
</script>
<style lang="less" scoped>
.columnList {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    .el-input {
      width: 500px;
      margin: 0 40px 0 20px;
    }
  }
  /deep/.el-table {
    margin-top: 50px;
  }
  .btn {
    margin-top: 30px;
  }
  .el-pagination {
    margin-top: 50px;
    float: right;
  }
}
</style>